import React, { useContext, useState, useEffect } from "react";
import TakTwitte from "./TakTwitte";
import twitteContext from "context/twitteContext";
import Comments from "./Comments";
import Swal from "sweetalert2";
import axios from "axios";

const TwitteModal = () => {
  const { twitte, updater, Iindex, setUpdater } = useContext(twitteContext);
  const [comments, setComments] = useState([]);
  useEffect(() => {
    let temp;
    temp = twitte.comments[0].sort(function (a, b) {
      return b.comment[0].mtm - a.comment[0].mtm;
    });
    setComments(temp);
  }, [twitte]);
  const [newComment, setNewComment] = useState("");
  const [tempNewComment, setTempNewComment] = useState("");
  let date = new Date();
  let tm = Math.floor(date.getTime() / 1000);
  async function apihandler() {
    let fd = new FormData();
    fd.append("muid", 3);
    fd.append("text", newComment);
    fd.append("mtm", tm);
    fd.append("twit_id", twitte.main_twit[0].id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/add_comment", fd)
      .then((res) =>
        res.data.status == 1
          ? (Swal.fire({
              title: "ثبت",
              text: "کامنت شما با موفقیت ثبت شد",
              confirmButtonText: "باشه",
              icon: "success",
            }),
            setUpdater(!updater))
          : Swal.fire({
              title: "خطا",
              text: "مشکلی در ثبت کامنت به وجود آمده است",
              confirmButtonText: "باشه",
              icon: "error",
            })
      );
  }
  // console.log(twitte);
  return (
    <div
      class="modal fade"
      id="TwitteModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body container1">
            <TakTwitte value={twitte} index={Iindex} />
            <div className="col-12 row comments">
              <div
                className="col-12"
                style={{
                  fontWeight: "bold",
                  marginRight: "20px",
                  marginTop: "40px",
                }}
              >
                نظرات کاربران
              </div>
              <div
                className="col-12"
                style={{ textAlign: "left", marginBottom: "20px" }}
              >
                <input
                  type="text"
                  placeholder="نظر خود را در اینجا وارد کنید."
                  className="commentInput"
                  onChange={(e) => setNewComment(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-primary commentButton"
                  onClick={(e) => apihandler()}
                >
                  ثبت نظر
                </button>
              </div>
              {comments.length != 0
                ? comments.map((value, index) => (
                    <div
                      className="col-12"
                      style={{ borderTop: "1px solid #B6BDAE" }}
                    >
                      <Comments
                        Comment={value}
                        index={index}
                        setComments={setComments}
                      />
                    </div>
                  ))
                : ""}
              {/* {comments.map((value, index) => (
                <div
                  className="col-12"
                  style={{ borderTop: "1px solid #B6BDAE" }}
                >
                  <Comments
                    Comment={value}
                    index={index}
                    setComments={setComments}
                  />
                </div>
              ))} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TwitteModal;
